/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.1.0 (NJsonSchema v10.3.3.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AuthClient {
    /**
     * Optional bearer token to be included in all requests
     */
    public bearerToken: string = "";
    /**
     * Methods to which CSRF security is applied
     */
    private csrfMethods: string[] = ["POST", "PUT", "DELETE", "PATCH"];

    constructor() {
        this.bearerToken = "";
        this.csrfMethods = ["POST", "PUT", "DELETE", "PATCH"];
    }

    public transformHttpRequestOptions(options: RequestInit): Promise<RequestInit> {
        const csrfToken = this.getCookieValue("XSRF-TOKEN");

        if (options.headers) {
            if (this.bearerToken !== undefined)
                (options.headers as any)['Authorization'] = 'Bearer ' + this.bearerToken!;

            if (csrfToken && csrfToken.length !== undefined && this.csrfMethods?.includes(options.method!))
                (options.headers as any)["X-CSRF-TOKEN"] = csrfToken!;
        }

        return Promise.resolve(options);
    }

    private getCookieValue(cookieName: string) {
        var results = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
        return results ? results.pop() : '';
    }
}

export interface IHerkePassportApiClient {
    account_Create(dto: CreateAccountDto): Promise<HerkePassportResponse<AccountCreationResultDto>>;
    account_CheckAvailability(email: string): Promise<HerkePassportResponse<AccountAvailabilityDto>>;
    account_Recovery(dto: AccountRecoveryDto): Promise<HerkePassportResponse<FileResponse>>;
    account_EmailConfirmation(id: string, dto: AccountEmailConfirmationDto): Promise<HerkePassportResponse<FileResponse>>;
    account_ResetPassword(id: string, dto: PasswordResetDto): Promise<HerkePassportResponse<FileResponse>>;
    account_CreateExternalReference(dto: CreateExternalUserReferenceDto, email?: string | null | undefined): Promise<HerkePassportResponse<FileResponse>>;
    authentication_GetAuthenticationContext(returnUrl?: string | null | undefined): Promise<HerkePassportResponse<AuthenticationContextDto>>;
    authentication_GetErrorContext(id?: string | null | undefined, name?: string | null | undefined, contextId?: string | null | undefined): Promise<HerkePassportResponse<ErrorMessage>>;
    authentication_SignIn(dto: SignInDto): Promise<HerkePassportResponse<SignInResultDto>>;
    authentication_GetSignOutContext(signOutId?: string | null | undefined): Promise<HerkePassportResponse<AuthenticationContextDto>>;
    authentication_Signout(dto: SignOutDto): Promise<HerkePassportResponse<FileResponse>>;
}

export class HerkePassportApiClient extends AuthClient implements IHerkePassportApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:50309";
    }

    account_Create(dto: CreateAccountDto, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<AccountCreationResultDto>> {
        let url_ = this.baseUrl + "/api/v2/Account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_Create(_response);
        });
    }

    protected processAccount_Create(response: Response): Promise<HerkePassportResponse<AccountCreationResultDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountCreationResultDto.fromJS(resultData200);
            return new HerkePassportResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<AccountCreationResultDto>>(new HerkePassportResponse(status, _headers, <any>null));
    }

    account_CheckAvailability(email: string, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<AccountAvailabilityDto>> {
        let url_ = this.baseUrl + "/api/v2/Account/checkAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_CheckAvailability(_response);
        });
    }

    protected processAccount_CheckAvailability(response: Response): Promise<HerkePassportResponse<AccountAvailabilityDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountAvailabilityDto.fromJS(resultData200);
            return new HerkePassportResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<AccountAvailabilityDto>>(new HerkePassportResponse(status, _headers, <any>null));
    }

    account_Recovery(dto: AccountRecoveryDto, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v2/Account/recovery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_Recovery(_response);
        });
    }

    protected processAccount_Recovery(response: Response): Promise<HerkePassportResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new HerkePassportResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<FileResponse>>(new HerkePassportResponse(status, _headers, <any>null));
    }

    account_EmailConfirmation(id: string, dto: AccountEmailConfirmationDto, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v2/Account/{id}/emailconfirmation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_EmailConfirmation(_response);
        });
    }

    protected processAccount_EmailConfirmation(response: Response): Promise<HerkePassportResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new HerkePassportResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<FileResponse>>(new HerkePassportResponse(status, _headers, <any>null));
    }

    account_ResetPassword(id: string, dto: PasswordResetDto, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v2/Account/{id}/recovery/passwordreset";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_ResetPassword(_response);
        });
    }

    protected processAccount_ResetPassword(response: Response): Promise<HerkePassportResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new HerkePassportResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<FileResponse>>(new HerkePassportResponse(status, _headers, <any>null));
    }

    account_CreateExternalReference(dto: CreateExternalUserReferenceDto, email?: string | null | undefined, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v2/Account/externalReferences?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccount_CreateExternalReference(_response);
        });
    }

    protected processAccount_CreateExternalReference(response: Response): Promise<HerkePassportResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new HerkePassportResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<FileResponse>>(new HerkePassportResponse(status, _headers, <any>null));
    }

    authentication_GetAuthenticationContext(returnUrl?: string | null | undefined, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<AuthenticationContextDto>> {
        let url_ = this.baseUrl + "/api/v2/Authentication/signin/context?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthentication_GetAuthenticationContext(_response);
        });
    }

    protected processAuthentication_GetAuthenticationContext(response: Response): Promise<HerkePassportResponse<AuthenticationContextDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticationContextDto.fromJS(resultData200);
            return new HerkePassportResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<AuthenticationContextDto>>(new HerkePassportResponse(status, _headers, <any>null));
    }

    authentication_GetErrorContext(id?: string | null | undefined, name?: string | null | undefined, contextId?: string | null | undefined, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<ErrorMessage>> {
        let url_ = this.baseUrl + "/api/v2/Authentication/error?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (contextId !== undefined && contextId !== null)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthentication_GetErrorContext(_response);
        });
    }

    protected processAuthentication_GetErrorContext(response: Response): Promise<HerkePassportResponse<ErrorMessage>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorMessage.fromJS(resultData200);
            return new HerkePassportResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<ErrorMessage>>(new HerkePassportResponse(status, _headers, <any>null));
    }

    authentication_SignIn(dto: SignInDto, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<SignInResultDto>> {
        let url_ = this.baseUrl + "/api/v2/Authentication/signin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthentication_SignIn(_response);
        });
    }

    protected processAuthentication_SignIn(response: Response): Promise<HerkePassportResponse<SignInResultDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignInResultDto.fromJS(resultData200);
            return new HerkePassportResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<SignInResultDto>>(new HerkePassportResponse(status, _headers, <any>null));
    }

    authentication_GetSignOutContext(signOutId?: string | null | undefined, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<AuthenticationContextDto>> {
        let url_ = this.baseUrl + "/api/v2/Authentication/signout/context?";
        if (signOutId !== undefined && signOutId !== null)
            url_ += "signOutId=" + encodeURIComponent("" + signOutId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthentication_GetSignOutContext(_response);
        });
    }

    protected processAuthentication_GetSignOutContext(response: Response): Promise<HerkePassportResponse<AuthenticationContextDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticationContextDto.fromJS(resultData200);
            return new HerkePassportResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<AuthenticationContextDto>>(new HerkePassportResponse(status, _headers, <any>null));
    }

    authentication_Signout(dto: SignOutDto, signal?: AbortSignal | undefined): Promise<HerkePassportResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v2/Authentication/signout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthentication_Signout(_response);
        });
    }

    protected processAuthentication_Signout(response: Response): Promise<HerkePassportResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new HerkePassportResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerkePassportResponse<FileResponse>>(new HerkePassportResponse(status, _headers, <any>null));
    }
}

export class AccountCreationResultDto implements IAccountCreationResultDto {
    succeeded?: boolean;
    requireEmailConfirmation?: boolean;

    constructor(data?: IAccountCreationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"] !== undefined ? _data["succeeded"] : <any>null;
            this.requireEmailConfirmation = _data["requireEmailConfirmation"] !== undefined ? _data["requireEmailConfirmation"] : <any>null;
        }
    }

    static fromJS(data: any): AccountCreationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCreationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded !== undefined ? this.succeeded : <any>null;
        data["requireEmailConfirmation"] = this.requireEmailConfirmation !== undefined ? this.requireEmailConfirmation : <any>null;
        return data; 
    }
}

export interface IAccountCreationResultDto {
    succeeded?: boolean;
    requireEmailConfirmation?: boolean;
}

export class CreateAccountDto implements ICreateAccountDto {
    givenName?: string | null;
    familyName?: string | null;
    email?: string | null;
    password?: string | null;

    constructor(data?: ICreateAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.givenName = _data["givenName"] !== undefined ? _data["givenName"] : <any>null;
            this.familyName = _data["familyName"] !== undefined ? _data["familyName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): CreateAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["givenName"] = this.givenName !== undefined ? this.givenName : <any>null;
        data["familyName"] = this.familyName !== undefined ? this.familyName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data; 
    }
}

export interface ICreateAccountDto {
    givenName?: string | null;
    familyName?: string | null;
    email?: string | null;
    password?: string | null;
}

export class AccountAvailabilityDto implements IAccountAvailabilityDto {
    isAvailable?: boolean;

    constructor(data?: IAccountAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"] !== undefined ? _data["isAvailable"] : <any>null;
        }
    }

    static fromJS(data: any): AccountAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable !== undefined ? this.isAvailable : <any>null;
        return data; 
    }
}

export interface IAccountAvailabilityDto {
    isAvailable?: boolean;
}

export class AccountRecoveryDto implements IAccountRecoveryDto {
    username?: string | null;

    constructor(data?: IAccountRecoveryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
        }
    }

    static fromJS(data: any): AccountRecoveryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountRecoveryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : <any>null;
        return data; 
    }
}

export interface IAccountRecoveryDto {
    username?: string | null;
}

export class AccountEmailConfirmationDto implements IAccountEmailConfirmationDto {
    token?: string | null;

    constructor(data?: IAccountEmailConfirmationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
        }
    }

    static fromJS(data: any): AccountEmailConfirmationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountEmailConfirmationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        return data; 
    }
}

export interface IAccountEmailConfirmationDto {
    token?: string | null;
}

export class PasswordResetDto implements IPasswordResetDto {
    password?: string | null;
    recoveryToken?: string | null;

    constructor(data?: IPasswordResetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.recoveryToken = _data["recoveryToken"] !== undefined ? _data["recoveryToken"] : <any>null;
        }
    }

    static fromJS(data: any): PasswordResetDto {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordResetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["recoveryToken"] = this.recoveryToken !== undefined ? this.recoveryToken : <any>null;
        return data; 
    }
}

export interface IPasswordResetDto {
    password?: string | null;
    recoveryToken?: string | null;
}

export class CreateExternalUserReferenceDto implements ICreateExternalUserReferenceDto {
    value?: string | null;
    displayName?: string | null;
    externalDataProvider?: ExternalDataProvider;

    constructor(data?: ICreateExternalUserReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.externalDataProvider = _data["externalDataProvider"] !== undefined ? _data["externalDataProvider"] : <any>null;
        }
    }

    static fromJS(data: any): CreateExternalUserReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExternalUserReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["externalDataProvider"] = this.externalDataProvider !== undefined ? this.externalDataProvider : <any>null;
        return data; 
    }
}

export interface ICreateExternalUserReferenceDto {
    value?: string | null;
    displayName?: string | null;
    externalDataProvider?: ExternalDataProvider;
}

export enum ExternalDataProvider {
    Dynamics365 = 1,
    Dynamics365BusinessCentral = 2,
    MicrosoftGraph = 3,
    MicrosoftIdentityPlatform = 4,
    TopDesk = 5,
    HerkePassport = 6,
    HerkeLogging = 7,
}

export class AuthenticationContextDto implements IAuthenticationContextDto {
    client?: PublicClientDetailViewModel | null;
    session?: SessionDto | null;
    returnUrl?: string | null;

    constructor(data?: IAuthenticationContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? PublicClientDetailViewModel.fromJS(_data["client"]) : <any>null;
            this.session = _data["session"] ? SessionDto.fromJS(_data["session"]) : <any>null;
            this.returnUrl = _data["returnUrl"] !== undefined ? _data["returnUrl"] : <any>null;
        }
    }

    static fromJS(data: any): AuthenticationContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["session"] = this.session ? this.session.toJSON() : <any>null;
        data["returnUrl"] = this.returnUrl !== undefined ? this.returnUrl : <any>null;
        return data; 
    }
}

export interface IAuthenticationContextDto {
    client?: PublicClientDetailViewModel | null;
    session?: SessionDto | null;
    returnUrl?: string | null;
}

export class PublicClientDetailViewModel implements IPublicClientDetailViewModel {
    id?: string;
    displayName?: string | null;
    environment?: PublicEnvironmentDetailViewModel | null;

    constructor(data?: IPublicClientDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.environment = _data["environment"] ? PublicEnvironmentDetailViewModel.fromJS(_data["environment"]) : <any>null;
        }
    }

    static fromJS(data: any): PublicClientDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicClientDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["environment"] = this.environment ? this.environment.toJSON() : <any>null;
        return data; 
    }
}

export interface IPublicClientDetailViewModel {
    id?: string;
    displayName?: string | null;
    environment?: PublicEnvironmentDetailViewModel | null;
}

export class PublicEnvironmentDetailViewModel implements IPublicEnvironmentDetailViewModel {
    displayName?: string | null;

    constructor(data?: IPublicEnvironmentDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
        }
    }

    static fromJS(data: any): PublicEnvironmentDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicEnvironmentDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        return data; 
    }
}

export interface IPublicEnvironmentDetailViewModel {
    displayName?: string | null;
}

export class SessionDto implements ISessionDto {
    id?: string;
    displayName?: string | null;
    email?: string | null;

    constructor(data?: ISessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): SessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data; 
    }
}

export interface ISessionDto {
    id?: string;
    displayName?: string | null;
    email?: string | null;
}

export class ErrorMessage implements IErrorMessage {
    title?: string | null;
    body?: string | null;
    appearance?: ErrorAppearance;
    details?: ErrorDetails | null;
    developerDetails?: DeveloperDetails | null;

    constructor(data?: IErrorMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.appearance = _data["appearance"] !== undefined ? _data["appearance"] : <any>null;
            this.details = _data["details"] ? ErrorDetails.fromJS(_data["details"]) : <any>null;
            this.developerDetails = _data["developerDetails"] ? DeveloperDetails.fromJS(_data["developerDetails"]) : <any>null;
        }
    }

    static fromJS(data: any): ErrorMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["appearance"] = this.appearance !== undefined ? this.appearance : <any>null;
        data["details"] = this.details ? this.details.toJSON() : <any>null;
        data["developerDetails"] = this.developerDetails ? this.developerDetails.toJSON() : <any>null;
        return data; 
    }
}

export interface IErrorMessage {
    title?: string | null;
    body?: string | null;
    appearance?: ErrorAppearance;
    details?: ErrorDetails | null;
    developerDetails?: DeveloperDetails | null;
}

export enum ErrorAppearance {
    Error = 1,
    Warning = 2,
    Critical = 3,
}

export class ErrorDetails implements IErrorDetails {
    application?: string | null;
    referenceId?: string | null;
    eventId?: number;
    localizedMessage?: LocalizedMessage | null;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] !== undefined ? _data["application"] : <any>null;
            this.referenceId = _data["referenceId"] !== undefined ? _data["referenceId"] : <any>null;
            this.eventId = _data["eventId"] !== undefined ? _data["eventId"] : <any>null;
            this.localizedMessage = _data["localizedMessage"] ? LocalizedMessage.fromJS(_data["localizedMessage"]) : <any>null;
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application !== undefined ? this.application : <any>null;
        data["referenceId"] = this.referenceId !== undefined ? this.referenceId : <any>null;
        data["eventId"] = this.eventId !== undefined ? this.eventId : <any>null;
        data["localizedMessage"] = this.localizedMessage ? this.localizedMessage.toJSON() : <any>null;
        return data; 
    }
}

export interface IErrorDetails {
    application?: string | null;
    referenceId?: string | null;
    eventId?: number;
    localizedMessage?: LocalizedMessage | null;
}

export class LocalizedMessage implements ILocalizedMessage {
    nl?: string | null;
    en?: string | null;

    constructor(data?: ILocalizedMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nl = _data["nl"] !== undefined ? _data["nl"] : <any>null;
            this.en = _data["en"] !== undefined ? _data["en"] : <any>null;
        }
    }

    static fromJS(data: any): LocalizedMessage {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nl"] = this.nl !== undefined ? this.nl : <any>null;
        data["en"] = this.en !== undefined ? this.en : <any>null;
        return data; 
    }
}

export interface ILocalizedMessage {
    nl?: string | null;
    en?: string | null;
}

export class DeveloperDetails implements IDeveloperDetails {
    message?: string | null;
    referenceId?: string | null;

    constructor(data?: IDeveloperDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.referenceId = _data["referenceId"] !== undefined ? _data["referenceId"] : <any>null;
        }
    }

    static fromJS(data: any): DeveloperDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DeveloperDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["referenceId"] = this.referenceId !== undefined ? this.referenceId : <any>null;
        return data; 
    }
}

export interface IDeveloperDetails {
    message?: string | null;
    referenceId?: string | null;
}

export class SignInResultDto implements ISignInResultDto {
    success?: boolean;
    returnUrl?: string | null;
    error?: string | null;

    constructor(data?: ISignInResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.returnUrl = _data["returnUrl"] !== undefined ? _data["returnUrl"] : <any>null;
            this.error = _data["error"] !== undefined ? _data["error"] : <any>null;
        }
    }

    static fromJS(data: any): SignInResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignInResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["returnUrl"] = this.returnUrl !== undefined ? this.returnUrl : <any>null;
        data["error"] = this.error !== undefined ? this.error : <any>null;
        return data; 
    }
}

export interface ISignInResultDto {
    success?: boolean;
    returnUrl?: string | null;
    error?: string | null;
}

export class SignInDto implements ISignInDto {
    userName?: string | null;
    password?: string | null;
    rememberLogin?: boolean | null;
    returnUrl?: string | null;

    constructor(data?: ISignInDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.rememberLogin = _data["rememberLogin"] !== undefined ? _data["rememberLogin"] : <any>null;
            this.returnUrl = _data["returnUrl"] !== undefined ? _data["returnUrl"] : <any>null;
        }
    }

    static fromJS(data: any): SignInDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["rememberLogin"] = this.rememberLogin !== undefined ? this.rememberLogin : <any>null;
        data["returnUrl"] = this.returnUrl !== undefined ? this.returnUrl : <any>null;
        return data; 
    }
}

export interface ISignInDto {
    userName?: string | null;
    password?: string | null;
    rememberLogin?: boolean | null;
    returnUrl?: string | null;
}

export class SignOutDto implements ISignOutDto {
    logoutId?: string | null;
    triggerExternalLogout?: boolean;

    constructor(data?: ISignOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoutId = _data["logoutId"] !== undefined ? _data["logoutId"] : <any>null;
            this.triggerExternalLogout = _data["triggerExternalLogout"] !== undefined ? _data["triggerExternalLogout"] : <any>null;
        }
    }

    static fromJS(data: any): SignOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoutId"] = this.logoutId !== undefined ? this.logoutId : <any>null;
        data["triggerExternalLogout"] = this.triggerExternalLogout !== undefined ? this.triggerExternalLogout : <any>null;
        return data; 
    }
}

export interface ISignOutDto {
    logoutId?: string | null;
    triggerExternalLogout?: boolean;
}

export class HerkePassportResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}